import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * 🏷️ GuildBuffsBadge — the small chip rail that sits next to the hero
 * name across the top bar / dashboard. Each active guild shard renders
 * as a compact chip (icon + label). Clicking the rail could later
 * open the Shards panel; for now it's an informational row.
 *
 * Owner directive Feb 2026: "Have a small box of each skill/active on
 * the user's hero name to show it. (i.e. guild bonus m-att by 40)"
 *
 * Zero chips when the user is not in a guild / all shards Lv 0, so
 * the component collapses to nothing visible.
 */
export default function GuildBuffsBadge({ compact = false, className = "" }) {
  const [badges, setBadges] = useState([]);
  const [chitFind, setChitFind] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    // Cookie-based auth via axios defaults (withCredentials: true).
    axios
      .get(`${API}/me/active-buffs`)
      .then((r) => {
        if (!alive) return;
        setBadges(r.data?.badges || []);
        setChitFind(Number(r.data?.chit_find_pct || 0));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!badges || badges.length === 0) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/aether-and-ash")}
      className={`flex flex-wrap items-center gap-1 cursor-pointer hover:opacity-100 opacity-90 transition-opacity ${className}`}
      data-testid="guild-buffs-badge-rail"
      title="Open Aether & Ash — your full stat sheet + power rating."
    >
      {badges.map((b) => (
        <span
          key={b.id}
          className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 ${
            b.source === "apex"
              ? "border-amber-500/50 bg-amber-900/20 text-amber-200"
              : "border-emerald-500/40 bg-emerald-900/20 text-emerald-200"
          } ${compact ? "text-[9px]" : "text-[10px]"} font-semibold`}
          data-testid={`guild-buff-chip-${b.id}`}
        >
          <span>{b.icon}</span>
          <span>{b.label}</span>
        </span>
      ))}
      {chitFind > 0 && !badges.find((b) => b.id === "guild_chit_finder") && (
        <span
          className="inline-flex items-center gap-1 rounded-full border border-yellow-500/40 bg-yellow-900/20 text-yellow-200 px-2 py-0.5 text-[10px] font-semibold"
          data-testid="guild-buff-chip-chit-finder"
        >
          <span>🪙</span>
          <span>Guild +{chitFind}% Chits</span>
        </span>
      )}
    </button>
  );
}
